import { render, staticRenderFns } from "./SavedFiltersList.vue?vue&type=template&id=ec922490&scoped=true"
import script from "./SavedFiltersList.vue?vue&type=script&lang=js"
export * from "./SavedFiltersList.vue?vue&type=script&lang=js"
import style0 from "./SavedFiltersList.vue?vue&type=style&index=0&id=ec922490&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec922490",
  null
  
)

export default component.exports